import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { EmployerInfo, Position } from '../consts/types/employer';
import { ReduxState } from "../consts/types/store";


/** State */
export interface EmployerState {
    currentEmployer?: EmployerInfo | null;
    authenticating: boolean;
    photoURL: string | null;
    positionToSearch?: Position;
}


/** Selectors */
export const EmployerSelectors = {
    currentEmployer: (state: ReduxState) => state.employer.currentEmployer,
    authenticating: (state: ReduxState) => state.employer.authenticating,
    photoURL: (state: ReduxState) => state.employer.photoURL,
    positionToSearch: (state: ReduxState) => state.employer.positionToSearch,

}


/** Reducer */

const initialState: EmployerState = {
    authenticating: true,
    photoURL: null,
}

const employerSlice = createSlice({
    name: 'employer',
    initialState: initialState,
    reducers: {
        setEmployer(state, action: PayloadAction<{ employer?: EmployerInfo | null }>) {
            state.currentEmployer = action.payload.employer;
        },
        setAuthenticating(state, action: PayloadAction<{ authenticating: boolean }>) {
            state.authenticating = action.payload.authenticating;
        },
        setPhotoUrl(state, action: PayloadAction<{ url: string | null }>) {
            state.photoURL = action.payload.url;
        },
        setPositionToSearch(state, action: PayloadAction<{ position?: Position  }>) {
            state.positionToSearch = action.payload.position;
        },
    }
})

export const employerActionsCreators = employerSlice.actions;
export default employerSlice.reducer